import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe27d3f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "no-access" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "No Access"),
  /*#__PURE__*/_createElementVNode("span", null, "You do not have access to this application.")
], -1))

export function render(_ctx, _cache) {
  const _component_PageHeader = _resolveComponent("PageHeader")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { appName: 'TRUST ADMIN' }),
    _hoisted_1
  ], 64))
}